import GraphConstants from 'app/shared/constants/GraphConstants';
import format from 'date-fns/format';

const CONFIGS = {
    listings: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.PROPERTIES,
        },
    },
    leads: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.LEADS,
        },
    },
    clicks: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.CLICKS,
        },
    },
    views: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.VIEWS,
        },
    },
    reviews: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.REVIEWS,
        },
        average: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.RATING,
            precision: 1,
            hideDataIfZero: true,
        },
    },
    coreProduct: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.CORE_PRODUCTS,
            precision: 2,
        },
    },
    boost: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.BOOST,
            precision: 2,
        },
    },
    rocketship: {
        total: {
            dataType: GraphConstants.GRAPH_DATA_TYPES.ROCKETSHIP,
            precision: 2,
        },
    },
};

// [{ config: { dataType: '', precision: 0, hideDataIfZero: false } data: { total: Number, months: [startDate, total] } }]
const GraphSection = (graphs) => {
    const result = {};
    const months = {};
    let isEmpty = true;
    graphs.forEach((graph) => {
        const {
            data,
            config,
        } = graph;
        const {
            dataType,
            precision,
            hideDataIfZero,
        } = config;
        if (data) {
            result[dataType] = Number(data.total).toFixed(precision || 0);
            data.months.forEach(({ startDate, total }) => {
                const existingMonth = months[startDate];
                if (!existingMonth) {
                    months[startDate] = {
                        name: `${format(new Date(startDate), 'MMM YYYY')}`,
                    };
                }
                if (!hideDataIfZero || total !== 0) {
                    isEmpty = false;
                    months[startDate][dataType] = Number(total).toFixed(precision || 0);
                }
            });
        } else {
            result[dataType] = 0;
        }
    });
    result.months = Object.values(months);
    result.isEmpty = isEmpty;
    return result;
};

// [{
//     configs: { total: { dataType, precision, hideDataIfZero }, average (optional) }
//     data: { total, average (optional) }
// }];
const Graph = (graphs) => {
    const total = [];
    const average = [];

    graphs.forEach((graph) => {
        const {
            configs,
            data,
        } = graph;
        const totalConfig = configs.total;
        const averageConfig = configs.average || totalConfig;
        total.push({
            config: totalConfig,
            data: data.total,
        });
        average.push({
            config: averageConfig,
            data: data.average,
        });
    });

    const result = {
        total: GraphSection(total),
        average: GraphSection(average),
    };

    return result;
};

const Graphs = ({
    listings, views, clicks, leads, reviews, coreProduct, boost, rocketship,
}) => {
    const graphs = {};

    if (listings) {
        graphs.property = Graph([{ configs: CONFIGS.listings, data: listings }]);
    }

    if (clicks || leads) {
        graphs.leadClick = Graph([
            {
                configs: CONFIGS.leads,
                data: leads,
            },
            {
                configs: CONFIGS.clicks,
                data: clicks,
            },
        ]);
    }

    if (views) {
        graphs.view = Graph([{ configs: CONFIGS.views, data: views }]);
    }

    if (reviews) {
        graphs.review = Graph([{ configs: CONFIGS.reviews, data: reviews }]);
    }

    if (coreProduct || boost || rocketship) {
        graphs.invoice = Graph([
            {
                configs: CONFIGS.coreProduct,
                data: coreProduct,
            },
            {
                configs: CONFIGS.boost,
                data: boost,
            },
            {
                configs: CONFIGS.rocketship,
                data: rocketship,
            },
        ]);
    }

    return graphs;
};

export default Graphs;
